import { Component, OnInit, Input } from "@angular/core";
import { BaseService } from "src/app/Services/Base.service";
declare var $: any;

@Component({
  selector: "app-error",
  templateUrl: "./error.component.html",
  styleUrls: ["./error.component.scss"]
})
export class ErrorComponent implements OnInit {
  lang: string;
  codeError: Number;
  titleError: String;
  msgError: String;

  constructor(private base: BaseService) {
    this.codeError = this.base.getInfoError().code;
    this.titleError = this.base.getInfoError().title;
    this.msgError = this.base.getInfoError().msg;
  }

  ngOnInit() {
    this.lang = this.base.getLang();
    $("section.error").css("height", $(window).height() - 100);
  }

  ngAfterContentChecked(): void {
    this.lang = this.base.getLang();
    this.codeError = this.base.getInfoError().code;
    this.titleError = this.base.getInfoError().title;
    this.msgError = this.base.getInfoError().msg;
  }
}
